module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABE0lEQVRoQ+2Y0REBQRBEuyNAJjJABGSEjIgAGcgEEYzaP5xzalSXra3e75ve7X6zV1NLNLLYiA/YSG0kTcRERAm4tUTBpmXfEomINYB5WlVbeCS5fd2iYyQixgAu2rP8rD4heX1U6SNyBDD7eTuNwIlkp1t82TVh51VNJJ+dptJENLnmVU0kn52m0kQ0ueZV2yYSEVMAy3w+0so9yfPg9Fs+iIgy/ZYpuMZ1JTn51kgZkUc1ugBwI9kJuW+ML621qtTI7uvWqtTAx2O1/dcykT8m4Nb6Y/hvtzYRExEl4NYSBZuW7Zu1DpU/Yi8Gp9/WHrE3lRMp53tavuzpWykqNBFRsGlZE0lHJyo0EVGwadlmiNwBxKwyM3i7oPwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navigate_menu.png
// module id = FICl
// module chunks = 8